import { createSelector } from '@reduxjs/toolkit';

import { selectCompSequence } from './orderSelectors.ts';

export const selectFirstOrFewerCompID = createSelector([selectCompSequence], (compSequence) => {
  if (compSequence.length === 0) return 'subject';

  return compSequence[0];
});
